<template>
  <main class="main">
    <div class="group">
      <p class="h2">Successfully logged out!</p>
    </div>
  </main>
</template>

<script>
import config from 'config';
// Vuex
import { mapActions } from 'vuex';

// Export
export default {
  name: `view-logout`,

  // Methods
  methods: {
    ...mapActions(`auth`, [
      `requestLogout`,
    ]),
  },

  // Lifecycle
  created() {
    this.requestLogout({
      noRedirect: true,
    })
      .then(() => {
        setTimeout(() => {
          window.location = config.wp;
        }, 600);
      });
  },
};
</script>



// WEBPACK FOOTER //
// Logout.vue?935048aa